export default "__VITE_ASSET__COSEFT4U__"